import React from 'react';
function OnlineStore({ size, stroke = 'currentColor', ...otherProps }) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke={stroke}
      {...otherProps}
    >
      <path d="M5.133 9.078a1.636 1.636 0 011.635-1.57h10.465c.877 0 1.599.692 1.634 1.57l.388 9.714a1.636 1.636 0 01-1.634 1.7H6.379a1.636 1.636 0 01-1.634-1.7l.388-9.715z" />
      <path
        strokeLinecap="round"
        d="M15.5 10l-.456-5.062a2.286 2.286 0 00-2.276-2.08h-1.536c-1.183 0-2.17.902-2.276 2.08L8.5 10"
      />
    </svg>
  );
}

export default OnlineStore;
